import { cities } from '@/lib/events-data';
import { DEFAULT_LOCALE, isSupportedLocale, type Locale } from '@todo/core/i18n/locales';

// Shared by app/[lang]/[city]. Unlike generateArticleStaticParams, this needs
// no fetch — the 7 Riviera cities are a static constant (src/lib/events-data.ts)
// — but returns the same `{lang, city}[]` shape for the same reason documented
// there: expo-router calls this as `generateStaticParams({ params: parentParams })`,
// and every returned object must carry the resolved `lang` explicitly or
// non-English locales silently fall back to English params.
export async function generateCityStaticParams({
  params,
}: {
  params: { lang?: string };
}): Promise<{ lang: string; city: string }[]> {
  const locale: Locale = isSupportedLocale(params.lang) ? params.lang : DEFAULT_LOCALE;
  return cities.map((city) => ({ lang: locale, city: city.id }));
}
